import pageMaintenanceApi from './page-maintenance-api';



// 为组件添加 install 方法，用于按需引入
pageMaintenanceApi.install = function (Vue) {
    Vue.component(pageMaintenanceApi.name, pageMaintenanceApi)
}




export default pageMaintenanceApi